import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('negociacao', 'roi');

const roiActions = {
  roiExtensoes: { method: 'GET', url: `${basePath}/extensoes{?idExtensao*}` },
  roiProduto: { method: 'GET', url: `${basePath}/produto/{idProduto}` },
};

export default resource => resource(`${basePath}`, {}, roiActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/negociacao/roi.js